export default __webpack_public_path__ + "static/media/plain-sticker-wi.8ddfbd41.png";